import styled from "styled-components";
import MsgBoxSelect from "../MsgBoxSelect/msg-box-select.component";

export const Folders = styled(MsgBoxSelect)`
	margin-bottom: -12px;
`;
